module.exports = __webpack_public_path__ + "static/media/79.d0b32b43.gif";